export default {
  methods: {
    handleData(field, value) {
      if (this.value[field] !== value) {
        const next = {
          ...this.value,
          valido: null,
          lineas: [],
          [field]: value
        };
        this.$emit("input", next);
      }
    },
    onCalle(calle) {
      this.handleData("calle", calle);
    },
    onNumero(numero) {
      this.handleData("numero", numero);
    },
    onPiso(piso) {
      this.handleData("piso", piso);
    },
    onDpto(dpto) {
      this.handleData("dpto", dpto);
    },
    onCP(codigoPostal) {
      this.handleData("codigoPostal", codigoPostal);
    },
    onLocalidad(localidad) {
      this.handleData("localidad", localidad);
    },
    onLocalid(localidad) {
      this.handleData("localid", localidad);
    },
    onProvincia(provincia) {
      this.handleData("codProvincia", provincia);
    },
    onCodProv(provincia) {
      this.handleData("codProv", provincia);
    }
  }
};
